module.exports = __webpack_public_path__ + "img/equalizer.6a879f5d.svg";